import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// ?safe&utm_source=google&country=US&area=activity-female-walking&exp=web_welcome_for_demgen_walking~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_welcome_for_demgen_walking'),
			},
		},
	},
]

export default config
